export const getProcessingDirectionUOFilter = state => state.directionUO.filter
